import React, { useState, useEffect } from 'react'
import RewardAnalyticsWidget from './RewardsAnalyticsWidget'
import { RewardAnalyticsWidgetType } from 'src/lib/types/rewards'
import { rewardsAnalyticsWidgetsConfig } from 'src/assets/RewardsConfig'
import NewDatePicker from 'src/components/common/search-and-filters/subcomponents/NewDatePicker'
import { appliedDateFilter, getDateTime } from 'src/lib/utils/helpers'
import { dashboardTabs } from 'src/lib/utils/constants'
import { TabType } from 'src/lib/types/filters'
import { RefreshCw } from 'react-feather'
import { useLocale } from 'src/lib/hooks/useLocal'
import { useDateFilters } from 'src/lib/hooks/useDateFilters'
import { FilterParentType } from 'src/lib/types/filters'
import { debounce } from 'lodash'

const RewardsAnalyticsTab = () => {
  const { dateFilter, setDateFilterCtx } = useDateFilters(dashboardTabs.FLO_REWARDS_ANALYTICS_TAB as FilterParentType)
  const { t } = useLocale()

  const date = new Date()
  const currentDate = new Date().toISOString()
  const currentMonthLastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1).toISOString().slice(0, 10)

  const handleRefresh = debounce(() => {
    setDateFilterCtx({
      ...dateFilter,
      lastUpdated: `${getDateTime(new Date()).date} at ${getDateTime(new Date()).time}`
    })
  }, 300)

  return (
    <div className='flex flex-col gap-4 w-full z-10'>
      <div className='flex flex-row justify-between'>
        <NewDatePicker
          dateFilter={dateFilter}
          setDateFilterCtx={setDateFilterCtx}
          appliedFilter={appliedDateFilter(dateFilter)}
          minDateValue={new Date(2022, 8, 20)}
          maxDateValue={new Date()}
          parentComponent={dashboardTabs.FLO_REWARDS_ANALYTICS_TAB as TabType}
          comparison
          hasCustomComparisons
        />

        <div className='flex flex-row gap-1 items-center justify-center'>
          <span className='text-sm text-coal-light'>{t('last_updated_on')} </span>
          <span className='text-sm text-coal-dark font-medium'>{dateFilter?.lastUpdated}</span>
          <button id='analytics-refresh-button' onClick={handleRefresh}>
            <RefreshCw id='analytics-refresh-button-icon' className='text-coal-dark stroke-[2.5px] h-4 w-4' />
          </button>
        </div>
      </div>
      <div className='w-full grid grid-flow-col-dense grid-cols-1 gap-4 md:grid-cols-3 '>
        {rewardsAnalyticsWidgetsConfig?.map((widgetData: RewardAnalyticsWidgetType, index: number) => {
          return (
            <RewardAnalyticsWidget
              key={index}
              widget={widgetData}
              filters={
                widgetData?.id === 'rewards_expiry'
                  ? {
                      startDate: currentDate,
                      endDate: currentMonthLastDay,
                      selectedStaticRange: 'thisMonth',
                      selectedCompareStaticRange: '30Days',
                      comparison: 'none'
                    }
                  : dateFilter
              }
            />
          )
        })}
      </div>
    </div>
  )
}

export default RewardsAnalyticsTab
